import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-events-timeline row q-col-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timeline_node = _resolveComponent("timeline-node")!
  const _component_timeline = _resolveComponent("timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_timeline, { class: "col-11" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (item) => {
          return (_openBlock(), _createBlock(_component_timeline_node, {
            heading: item.heading,
            type: item.type,
            style: _normalizeStyle(item.styles),
            "sub-heading": item.subHeading,
            description: item.description,
            "meta-data": item?.meta ? item.meta : undefined,
            updatedBy: item.created_by,
            message: item.message
          }, {
            head: _withCtx(({heading}) => [
              _createTextVNode(_toDisplayString(heading), 1)
            ]),
            description: _withCtx(({description}) => [
              _createTextVNode(_toDisplayString(description), 1)
            ]),
            updated_by: _withCtx(({updated_by}) => [
              _cache[0] || (_cache[0] = _createElementVNode("i", null, "by ", -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.getUsername(updated_by)), 1)
            ]),
            sub_heading: _withCtx(({sub_heading}) => [
              _createTextVNode(_toDisplayString(sub_heading), 1)
            ]),
            default: _withCtx(({ metadata }) => [
              _renderSlot(_ctx.$slots, "default", { metadata: metadata })
            ]),
            _: 2
          }, 1032, ["heading", "type", "style", "sub-heading", "description", "meta-data", "updatedBy", "message"]))
        }), 256))
      ]),
      _: 3
    })
  ]))
}